import { render, staticRenderFns } from "./ResidentialTemplates.vue?vue&type=template&id=a977713e"
import script from "./ResidentialTemplates.vue?vue&type=script&lang=js"
export * from "./ResidentialTemplates.vue?vue&type=script&lang=js"
import style0 from "./ResidentialTemplates.vue?vue&type=style&index=0&id=a977713e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports